import React, {FC} from "react";
import {Flex} from "../../../../../newShared/components/Layouts";
import {Typography} from "@mui/material";
import colors from "../../../../../newShared/theme/colors";
import * as S from "../../../newIntegrations/components/styled";
import {TReportIntegration} from "../../types";
import {useReport} from "../../hooks/useReport";
import {useReports} from "../../hooks/useReports";

type TProps = {
    app: TReportIntegration
}
export const ReportIntegrationCard: FC<TProps> = ({app}) => {
    const {report: {report}} = useReport();
    const {goToReportApp} = useReports();

    return (
        <S.IntegrationCard onClick={() => report && goToReportApp(report.id, app.id, report.archived)}>
            <Flex w={'100%'} jc={'center'}>
                <img src={app.logo || undefined} alt={app.name} width={'40%'}/>
            </Flex>

            <Flex w={'100%'} jc={'center'}>
                <Typography
                    color={colors.grayText}
                    fontSize={'16px'}
                    fontWeight={700}
                    sx={{
                        margin: '8px 0 0 0',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: 'normal',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {app.name}
                </Typography>
            </Flex>
        </S.IntegrationCard>
    )
}